var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-menu-drawer" }, [
    _c(
      "div",
      { staticClass: "course-list" },
      [
        _c(
          "el-collapse",
          {
            staticClass: "uni-collapse",
            attrs: { accordion: "" },
            model: {
              value: _vm.sectionUuid,
              callback: function ($$v) {
                _vm.sectionUuid = _vm._n($$v)
              },
              expression: "sectionUuid",
            },
          },
          [
            _c("div", { staticClass: "collapse-line" }),
            _vm._l(_vm.collapseDatas, function (item, index) {
              return _c(
                "el-collapse-item",
                {
                  key: item.id,
                  attrs: { name: item.id },
                  on: {
                    click: function ($event) {
                      _vm.sectionUuid = item.id
                    },
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    item.id != _vm.lessonsUuid
                      ? _c("i", {
                          staticClass: "uni-ico iconfont iconjiahao mar10 f20",
                          staticStyle: { color: "#cdcdcd" },
                        })
                      : _c("i", {
                          staticClass: "uni-ico iconfont iconjianhao mar10 f20",
                          staticStyle: { color: "#cdcdcd" },
                        }),
                    _c("span", { staticClass: "tit" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                  ]),
                  _vm._l(item.node, function (item2, index2) {
                    return _c(
                      "div",
                      {
                        key: item2.id,
                        staticClass: "item",
                        class: item2.id == _vm.lessonsUuid ? "active" : "",
                        on: {
                          click: function ($event) {
                            return _vm.changeLesson(item2.id, index, index2)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "iconfont iconbofang mar10" }),
                        _c("span", [_vm._v(_vm._s(item2.title))]),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }